module.exports = __webpack_public_path__ + "static/img/corenrTechnicalOne.87c3460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corenrTechnicalOne.png
// module id = qDUw
// module chunks = 1